import { Component, SVGProps } from 'react';
import SVG from '.';
interface SVGIconSearchProps extends SVGProps<any> {}
export class SVGIconBackSet extends Component<SVGIconSearchProps> {
  render() {
    const { width = 7, height = 14, color = '#11465D', ...rest } = this.props;
    return (
      <SVG
        className="svg-icon-angle"
        width={`${width}`}
        height={`${height}`}
        viewBox={`0 0 7 14`}
        fill={color}
        {...rest}
      >
        <g>
          <path
            d="M5.82737 14L0.569782 8.44667C0.207992 8.06329 0.00488281 7.5444 0.00488281 7.0035C0.00488281 6.4626 0.207992 5.94371 0.569782 5.56033L5.83401 0L7.00488 1.23725L1.74065 6.797C1.68881 6.8517 1.65969 6.92587 1.65969 7.00321C1.65969 7.08055 1.68881 7.15472 1.74065 7.20942L6.9988 12.7627L5.82737 14Z"
            fill={color}
          />
        </g>
      </SVG>
    );
  }
}
